// Exact opencode-go/glm-5.3 labels, session ses_f0b60382effeqseQu2YmRI8OLz.
// Reviewed with Matthew, Hermes and unslop writing rules.
export const careReactions = [
  { emoji: '👍', label: 'Thumbs up' },
  { emoji: '❤️', label: 'Red heart' },
  { emoji: '😂', label: 'Laughing face' },
  { emoji: '😮', label: 'Surprised face' },
  { emoji: '😢', label: 'Sad face' },
]
